const noop = (): null => null;

/**
 * Get the performance entries for the given type
 */
export function performanceEntries({
    type,
    buffered = true,
    durationThreshold,
}: {
    type: string;
    buffered?: boolean;
    durationThreshold?: DOMHighResTimeStamp;
}): PerformanceEntry[] {
    const observer = new PerformanceObserver(noop);
    observer.observe({
        type,
        buffered,
        durationThreshold,
    } as PerformanceObserverInit);
    const entries = observer.takeRecords?.();
    observer.disconnect();
    return entries || [];
}
